import { render, staticRenderFns } from "./Picture-input.vue?vue&type=template&id=6b9a7dee&scoped=true&"
import script from "./Picture-input.vue?vue&type=script&lang=js&"
export * from "./Picture-input.vue?vue&type=script&lang=js&"
import style0 from "./Picture-input.vue?vue&type=style&index=0&id=6b9a7dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a7dee",
  null
  
)

export default component.exports